export const NAME_REGEX = /^[a-zA-ZÀ-ÖØ-öø-ÿ' -]*$/;
export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9])[^\s]{8,}$/;
